export interface ReconcileGlobalClassFilterInput {
  storedClassIds: string[];
  availableClassIds: string[];
  dashboardClassIds?: string[];
}

export const reconcileGlobalClassFilter = ({
  storedClassIds,
  availableClassIds,
  dashboardClassIds = [],
}: ReconcileGlobalClassFilterInput): string[] => {
  const available = new Set(availableClassIds);

  const stored = storedClassIds.filter(id => available.has(id));
  if (stored.length) return stored;

  const fromDashboard = dashboardClassIds.filter(id => available.has(id));
  if (fromDashboard.length) return fromDashboard;

  return availableClassIds.slice(0, 1);
};
